<form (ngSubmit)="setPassword()" tabindex="0">
<div class="link-password-container">
    <div class="error" *ngIf="errcode">
        <app-error [errcode]="errcode"></app-error>
    </div>
    <img src="assets/icons/Protected.svg">
    <div class="info">
        <div class="h5">This link is password protected</div>
        <div class="body-1">If you do not have a password you'll need to contact the person who sent you the link.</div>
    </div>
        <sync-text-field
            inputType="password"
            label="Password"
            placeholder="Password"
            [(value)]="passwordfield"
            [errorMessage]="errcode?.code === 8019 ? 'Enter a valid password.' : ''"
        ></sync-text-field>
        <sync-button 
            type="filled"
            label="Submit"
            size="large"
            nativeType="submit"
            [isLoading]="spinner"
        ></sync-button>
    </div>
</form>